import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=e56746dc&scoped=true&"
import script from "./Identify.vue?vue&type=script&lang=js&"
export * from "./Identify.vue?vue&type=script&lang=js&"
import style0 from "./Identify.vue?vue&type=style&index=0&id=e56746dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56746dc",
  null
  
)

export default component.exports